export default date => {
  const new_date = new Date(date);
  return `${new_date.getFullYear()}年${new_date.getMonth() +
    1}月${new_date.getDate()}日`;
};
